import Swiper from 'swiper';
import { Navigation, Autoplay, FreeMode } from 'swiper/modules';

import gsap from "gsap";
// Nav menu mobile rwd

const btnMob = document.querySelector(".mobile-nav-btn");
const navMobActive = document.querySelector(".nav-mobil-on");

btnMob.addEventListener("click", function () {
  btnMob.classList.toggle("active");
  navMobActive.classList.toggle("active-nav-mob");
});


// =====================================================================
//  H   H  PPPP         GGG     A    L      L      EEEEE  RRRR   Y   Y
//  H   H  P   P       G   G   A A   L      L      E      R   R  Y   Y
//  HHHHH  P   P       G      A   A  L      L      EEE    R   R   Y Y
//  H   H  PPPP        G  GG  AAAAA  L      L      E      RRRR     Y
//  H   H  P           G   G  A   A  L      L      E      R  R     Y
//  H   H  P            GGGG  A   A  LLLLL  LLLLL  EEEEE  R   R    Y
// =====================================================================
// * * * HP gallery

// const isHp = document.getElementById('hpTeam');
// const isRealSingle = document.getElementById('singleSection');

// if (isHp) {
//   const swiper = new Swiper('.mySwiper', {
//     modules: [Navigation],
//     slidesPerView: 2,
//     spaceBetween: 20,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     breakpoints: {
//       760: {
//         slidesPerView: 3,
//         spaceBetween: 20,
//       },
//       1024: {
//         slidesPerView: 4,
//         spaceBetween: 20,
//       },
//     },
//   });

//   const swiperHero = new Swiper(".swiper--marquee", {
//     // modules
//     modules: [Autoplay, FreeMode],
//     freeMode: true,
//     autoplay: {
//       delay: 200,
//       disableOnInteraction: false,
//     },
//     speed: 3000,
//     slidesPerView: 2,
//     breakpoints: {
//       640: {
//         slidesPerView: 2,
//       },
//       768: {
//         slidesPerView: 3.1,
//       },
//       1220: {
//         slidesPerView: 4,
//       },
//     },
//   });
// }

// if (isRealSingle) {
//   const swiper = new Swiper('.mySwiperGal', {
//     modules: [Navigation],
//     slidesPerView: 1,
//     spaceBetween: 8,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//   });

//   document.addEventListener("DOMContentLoaded", function (event) {
//     Chocolat(document.querySelectorAll('.chocolat-parent .chocolat-image'))
//   })
// }

const testiPage = document.getElementById('serveTemoin');

if (testiPage) {

  var swiper = new Swiper(".mySwiper", {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1080: {
        slidesPerView: 2,
      }
    },
  });




}

// ====================================
//    A     CCC   TTTTT  U   U   SSS
//   A A   C   C    T    U   U  S
//  A   A  C        T    U   U   SSS
//  AAAAA  C        T    U   U      S
//  A   A  C   C    T    U   U      S
//  A   A   CCC     T     UUU   SSSS
// ====================================
// * * * Actus

const isListFilter = document.querySelector(".sort-section");
const isfaq = document.querySelector(".sort-faq");
const Single = document.querySelector(".sort-real");

if (isListFilter) {
  var box = $(".actus__card"),
    boxContainer = $(".actus__content__wrapper"),
    section = $(".sort-section"),
    // containerHeight = $('.adjustable-height'),
    boxClassFilter,
    showThese;

  $("button").on("click", function () {
    boxClassFilter = $(this).data("filter");
    showThese = boxContainer.find(".actus__card" + "." + boxClassFilter);
    var sectionHeight = section.height();

    $(".cat-container").find("button.selected").removeClass();
    $(this).toggleClass("selected");

    var tl = new gsap.timeline()
      .to(box, 0.5, { opacity: 0 })
      .set(box, { display: "none" })
      .set(showThese, { display: "flex" })
      .to(showThese, 0.8, { opacity: 1 }, "+=0.1")
      .fromTo(
        section,
        1,
        { height: "sectionHeight" },
        { height: "initial" },
        "-=1"
      );

    if (boxClassFilter == "all") {
      var allTL = new gsap.timeline()
        .set(section, { height: sectionHeight })
        .to(box, 0.5, { opacity: 0 })
        .set(box, { display: "none" })
        .set(box, { display: "flex" })
        .to(box, 0.8, { opacity: 1 }, "+=0.1")
        .fromTo(
          section,
          1,
          { height: "sectionHeight" },
          { height: "initial" },
          "-=1"
        );
    }
  });

} else if (isfaq) {

  var box = $(".tabs"),
    boxContainer = $(".faq__list__wrapper"),
    section = $(".sort-faq"),
    // containerHeight = $('.adjustable-height'),
    boxClassFilter,
    showThese;

  $("button").on("click", function () {
    boxClassFilter = $(this).data("filter");
    showThese = boxContainer.find(".tabs" + "." + boxClassFilter);
    var sectionHeight = section.height();

    $(".faqFilter__track").find("button.selected").removeClass();
    $(this).toggleClass("selected");

    var tl = new gsap.timeline()
      .to(box, 0.5, { opacity: 0 })
      .set(box, { display: "none" })
      .set(showThese, { display: "flex" })
      .to(showThese, 0.8, { opacity: 1 }, "+=0.1")
      .fromTo(
        section,
        1,
        { height: "sectionHeight" },
        { height: "initial" },
        "-=1"
      );

    if (boxClassFilter == "all") {
      var allTL = new gsap.timeline()
        .set(section, { height: sectionHeight })
        .to(box, 0.5, { opacity: 0 })
        .set(box, { display: "none" })
        .set(box, { display: "flex" })
        .to(box, 0.8, { opacity: 1 }, "+=0.1")
        .fromTo(
          section,
          1,
          { height: "sectionHeight" },
          { height: "initial" },
          "-=1"
        );
    }
  });
}